import { ProvisionedAppType } from "./provisioned/types";

export const normalizeTitle = (title: string) =>
  title.toLowerCase().replace(/\s+/g, "");

export const getStackNameFromResource = (
  resource: ProvisionedAppType,
  orchestrationStacks: Record<string, any> | undefined,
): string => {
  const isHeatDeployment =
    resource.deploymentTypeTitle.toLowerCase() === "heat";
  if (isHeatDeployment && resource.resourceId && orchestrationStacks) {
    const orchestrationStack =
      orchestrationStacks[resource.resourceId as string];
    return orchestrationStack?.stack_name || "";
  }
  return "";
};
